export default "__VITE_ASSET__BCfSnFOE__"